// ** React Imports
import React, { useState, useEffect } from 'react'

import Divider from '@mui/material/Divider'
import Icon from '../../../@core/components/icon'

import Box from '@mui/material/Box'
import { DataGrid } from '@mui/x-data-grid'
import CustomChip from '../table/Chip'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'

import CustomAvatar from '../../../@core/components/mui/avatar'
import CustomTextField from '../../../@core/components/mui/text-field'
import { fileBoxes } from './Pending'
import { copyToClipboard } from '../../functions/clipboardUtils'
import Spinner from '../../../@core/components/spinner'

const Completed = props => {
  const { loading } = props
  const [value, setValue] = useState('')
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 10 })
  const [openFileView, setOpenFileView] = useState(null)

  const [viewData, setViewData] = useState([])
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event, data) => {
    setOpenFileView(data)
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const openPopover = Boolean(anchorEl);

  const handleChange = event => {
    setValue(event.target.value)
  }

  const handleClickOpen = (error) => {
    setValue(error)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  let fileName = ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims']


  const userStatusObj = {
    active: 'success',
    pending: 'warning',
    inactive: 'secondary'
  }

  const tableData = [
    { id: "1", status: "success", fullName: 'Galen Slixby', email: 'gslixby0@abc.net.au', role: 'editor', billing: 'Auto Debit', currentPlan: 'enterprise', last_updated: '2025-02-17', error: 'Error1', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'spf Claims'] },
    { id: "2", status: "warning", fullName: 'Halsey Redmore', email: 'hredmore1@imgur.com', role: 'author', billing: 'Manual - Paypal', currentPlan: 'team', last_updated: '2025-02-17', error: 'Error2', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'spf Claims'] },
    { id: "3", status: "success", fullName: 'Marjory Sicely', email: 'msicely2@who.int', role: 'maintainer', billing: 'Manual - Cash', currentPlan: 'enterprise', last_updated: '2025-02-17', error: 'Error3', balance: '100', pendingFile: ['Payment', 'Order', 'Payment', 'spf Claims'] },
    { id: "4", status: "success", fullName: 'Cyrill Risby', email: 'crisby3@wordpress.com', role: 'maintainer', billing: 'Auto Debit', currentPlan: 'team', last_updated: '2025-02-17', error: 'Error4', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "5", status: "warning", fullName: 'Maggy Hurran', email: 'mhurran4@yahoo.co.jp', role: 'subscriber', billing: 'Auto Debit', currentPlan: 'enterprise', last_updated: '2025-02-17', error: 'Error5', balance: '100', pendingFile: ['Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "6", status: "error", fullName: 'Silvain Halstead', email: 'shalstead5@shinystat.com', role: 'author', billing: 'Manual - Cash', currentPlan: 'company', last_updated: '2025-02-17', error: 'Error6', balance: '100', pendingFile: ['Payment', 'intransit', 'Payment', 'spf Claims'] },
    { id: "7", status: "warning", fullName: 'Breena Gallemore', email: 'bgallemore6@boston.com', role: 'subscriber', billing: 'Manual - Paypal', currentPlan: 'company', last_updated: '2025-02-17', error: 'Error7', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "8", status: "warning", fullName: 'Kathryne Liger', email: 'kliger7@vinaora.com', role: 'author', billing: 'Auto Debit', currentPlan: 'enterprise', last_updated: '2025-02-17', error: 'Error8', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "9", status: "success", fullName: 'Franz Scotfurth', email: 'fscotfurth8@dailymotion.com', role: 'subscriber', billing: 'Manual - Credit Card', currentPlan: 'team', last_updated: '2025-02-17', error: 'Error9', balance: '100', pendingFile: ['intransit', 'Payment', 'spf Claims'] },
    { id: "10", status: "success", fullName: 'Jillene Bellany', email: 'jbellany9@kickstarter.com', role: 'maintainer', billing: 'Manual - Credit Card', currentPlan: 'company', last_updated: '2025-02-17', error: 'Error10', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "11", status: "success", fullName: 'Jonah Wharlton', email: 'jwharltona@oakley.com', role: 'subscriber', billing: 'Auto Debit', currentPlan: 'team', last_updated: '2025-02-17', error: 'Error', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "12", status: "success", fullName: 'Seth Hallam', email: 'shallamb@hugedomains.com', role: 'subscriber', billing: 'Auto Debit', currentPlan: 'team', last_updated: '2025-02-17', error: 'Error', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "13", status: "error", fullName: 'Yoko Pottie', email: 'ypottiec@privacy.gov.au', role: 'subscriber', billing: 'Manual - Cash', currentPlan: 'basic', last_updated: '2025-02-17', error: 'Error', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "14", status: "error", fullName: 'Maximilianus Krause', email: 'mkraused@stanford.edu', role: 'author', billing: 'Manual - Paypal', currentPlan: 'team', last_updated: '2025-02-17', error: 'Error', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "15", status: "error", fullName: 'Zsazsa McCleverty', email: 'zmcclevertye@soundcloud.com', role: 'maintainer', billing: 'Manual - Credit Card', currentPlan: 'enterprise', last_updated: '2025-02-17', error: 'Error', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "16", status: "error", fullName: 'Bentlee Emblin', email: 'bemblinf@wired.com', role: 'author', billing: 'Auto Debit', currentPlan: 'company', last_updated: '2025-02-17', error: 'Error', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
    { id: "17", status: "error", fullName: 'Brockie Myles', email: 'bmylesg@amazon.com', role: 'maintainer', billing: 'Manual - Paypal', currentPlan: 'basic', last_updated: '2025-02-17', error: 'Error', balance: '100', pendingFile: ['Payment', 'Order', 'intransit', 'Payment', 'spf Claims'] },
  ];

  useEffect(() => {
    setViewData(tableData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const columns = [
    {
      flex: 0.20,
      minWidth: 250,
      field: 'fullName',
      headerName: 'Trueseller Id',
      renderCell: ({ row }) => {
        const { fullName, email } = row

        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <CustomAvatar
              skin='light'
              color={row.avatarColor}
              sx={{ mr: 2.5, width: 38, height: 38, fontWeight: 500, fontSize: theme => theme.typography.body1.fontSize }}
            >
              {row.fullName.split(/\s/).reduce((response, word) => (response += word.slice(0, 1)), '')}
            </CustomAvatar>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
              <Typography
                noWrap

                // component={Link}
                sx={{
                  fontWeight: 500,
                  textDecoration: 'none',
                  color: 'text.secondary',
                  '&:hover': { color: 'primary.main' }
                }}
              >
                {fullName}
                <Icon icon="iconamoon:copy-duotone" width="16" height="16" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(`${fullName}`, 'Platform Id')} />
              </Typography>
              <Typography noWrap variant='body2' sx={{ color: 'text.disabled' }}>
                {email}
                <Icon icon="iconamoon:copy-duotone" width="12" height="12" style={{ color: '#7367f0' }} onClick={() => copyToClipboard(`${email}`, 'trueseller Id')} />
              </Typography>
            </Box>
          </Box>
        )
      }
    },
    {
      flex: 0.12,
      minWidth: 120,
      field: 'Plan',
      headerName: 'Company Name',
      renderCell: ({ row }) => {
        return (
          <Typography noWrap sx={{ fontWeight: 500, color: 'text.secondary', textTransform: 'capitalize' }}>
            {row.currentPlan}
          </Typography>
        )
      }
    },
    {
      flex: 0.13,
      minWidth: 190,
      field: 'billing',
      headerName: 'Supplier ID',
      renderCell: ({ row }) => {
        return (
          <Typography noWrap sx={{ color: 'text.secondary' }}>
            {row.billing}
          </Typography>
        )
      }
    },
    {
      flex: 0.15,
      minWidth: 110,
      field: 'status',
      headerName: 'Completed File',
      renderCell: ({ row }) => {
        return (
          <Typography noWrap sx={{ color: 'text.secondary' }} aria-owns={open ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"

          // onClick={(e) => handlePopoverOpen(e, row.pendingFile)}
          >
            {fileBoxes
              .filter((box) => row.pendingFile.includes(box.id)) // Filter relevant fileBoxes
              .map((box, index, array) => (
                <CustomChip
                  key={box.id} // Unique key to prevent unnecessary re-renders
                  rounded
                  label={box.label}
                  style={{ margin: '0 2px' }}
                  skin="light"
                  color="success"
                />
              ))
            }
          </Typography>
        )
      }
    },

    {
      flex: 0.1,
      minWidth: 110,
      field: 'last_updated',
      headerName: 'Last Updated',
      renderCell: ({ row }) => {
        return (
          <Typography noWrap sx={{ color: 'text.secondary' }}>
            {row.last_updated}
          </Typography>
        )
      }
    },
  ]

    if (loading) {
      return <div style={{ width: "100%", paddingTop: "50px" }}>
        <Spinner height={"100%"} />
      </div>
    }

  const renderContent = () => {
    return <Box style={{ width: '100%' }}>
      <Divider sx={{ m: '0 !important' }} />
      <DataGrid
        autoHeight
        rowHeight={55}
        rows={viewData}
        columns={columns}
        disableRowSelectionOnClick
        pageSizeOptions={[10, 25, 50]}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
      />

      <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth='sm' aria-labelledby='max-width-dialog-title'>
        <DialogTitle id='form-dialog-title'>Subscribe</DialogTitle>
        <DialogContent>
          <CustomTextField
            fullWidth
            rows={4}
            multiline

            // label='Multiline'
            defaultValue='Default Value'
            id='textarea-outlined-static'
            value={value}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions className='dialog-actions-dense'>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleClose} variant="contained">Save</Button>
        </DialogActions>
      </Dialog>
      {/* <Popover
        id="mouse-over-popover"
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={{ display: 'flex', py: 1, px: 2, backgroundColor: grey[50], gap: 1 }}>
          {openFileView && openFileView.map((item, index) => (
            <CustomChip rounded key={index} label={item.charAt(0)} skin='light' color='success' />
          ))}
        </Box>
      </Popover> */}
    </Box>
  }

  return renderContent()
}

export default Completed

